import URI from 'urijs';
import ie from './ie';

class FetchError extends Error {
  constructor(url, res) {
    super(`Error fetching url ${url}`);
    this.url = url;
    this.res = res;
    this.name = 'FetchError';
  }
}

const withQueryString = url => {
  if (!ie) {
    return url;
  }

  const timestamp = Date.now().toString();
  return URI(url)
    .addQuery(timestamp)
    .toString();
};

const withNoCacheHeaders = params => {
  if (!ie) {
    return params;
  }

  if (!params.headers) {
    params.headers = {};
  }

  params.headers['X-Requested-With'] = 'XMLHttpRequest';
  params.headers['Expires'] = '-1';
  params.headers['Cache-Control'] =
    'no-cache,no-store,must-revalidate,max-age=-1,private';

  return params;
};

export default function fetchUrl(url, params = {}) {
  const allParams = {
    credentials: 'same-origin',
    ...params,
  };
  return fetch(withQueryString(url), withNoCacheHeaders(allParams)).then(
    res => {
      if (res.status < 400) {
        return res;
      } else {
        throw new FetchError(url, res);
      }
    }
  );
}

export const fetchJson = (url, params) =>
  fetchUrl(url, {
    ...params,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(res => res.json());

export const postJson = (url, body, params = {}) =>
  fetchJson(url, {
    ...params,
    method: 'POST',
    body,
  });

export const putJson = (url, body, params = {}) =>
  fetchJson(url, {
    ...params,
    method: 'PUT',
    body,
  });



// WEBPACK FOOTER //
// ./src/utils/fetch.js